var map = {
	"./AI-Assistant.svg": 58469,
	"./Countries.svg": 9186,
	"./Currencies.svg": 71925,
	"./Directory.svg": 28850,
	"./Languages.svg": 26349,
	"./Notifications.svg": 8160,
	"./Organization.svg": 92377,
	"./Organizations.svg": 27832,
	"./Readiness.svg": 19068,
	"./Salaries.svg": 71738,
	"./grid-01.svg": 50632,
	"./image-01.svg": 5677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21690;